<template>
  <div>
    <div>
      <v-card>
        <v-spacer></v-spacer>
        <v-toolbar
            elevation="1"
            color="#BC0000"
            dark
        >
          <v-card-title class="d-flex justify-center pt-1">
            <h2 class="text-center">Adicionar Subcategoria</h2>
          </v-card-title>

          <v-btn color="#ccc" icon @click="close">
            <v-icon size="22">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-form class="mb-6" ref="form" v-model="valid">
            <v-row class="ma-0 pa-0">
              <v-col cols="12" sm="12" md="12" lg="12">
                <span class="label-details">Nome da subcategoria</span>
                <v-text-field
                    clearable
                    outlined
                    hide-details
                    :rules="[(v) => !!v || 'Campo obrigatório']"
                    v-model="currentSubCategory.name"
                    placeholder="nome"
                    style="border: 1px solid #979797; border-radius: 7.5px"
                    color="black"
                    full-width
                    background-color="#F5F5F5"
                    @keydown.enter="openDialog"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="12" md="12" lg="12">
                <span class="label-details">Descrição</span>
                <quill-editor
                    :content="currentSubCategory.descriptionHtml"
                    @change="onEditorChange($event)"
                    ref="myQuill"
                >
                </quill-editor>
              </v-col>
            </v-row>

            <v-row class="ma-0 mt-3 mb-2" align="end" justify="between" cols="12">
              <v-col cols="12" sm="10" md="10" lg="10">
                <label class="label-details">Palavra-chave</label>
                <v-text-field
                    outlined
                    v-model="keyWord"
                    placeholder="Digite a palavra-chave"
                    class="mt-2"
                    style="border: 1px solid #979797; border-radius: 5px"
                    color="black"
                    full-width
                    background-color="#F5F5F5"
                    hide-details
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="2" md="2" lg="2">
                <v-btn
                    fab
                    tile
                    height="60"
                    width="100%"
                    style="border-radius: 6px; margin-bottom: -2px"
                    small
                    elevation="0"
                    @click="addkeyWord()"
                    color="red"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-col>
            </v-row>

            <v-row class="ma-0 mt-3 mx-0 mb-2" align="end" justify="between" cols="12" v-if="keyWords && keyWords.length > 0">
              <v-col cols="12" sm="12" md="12" lg="12" >
                <p class="label-details">Palavras-chave</p>
                <section class="keyWords">
                  <p
                      class="d-inline-flex align-center mr-2 keyWord"
                      v-for="(keyWord, index) in keyWords" :key="`${index}-${keyWord}`"
                  >
                <span>
                  {{keyWord}}
                </span>

                    <v-icon
                        size="20"
                        color="#FFFFFF"
                        style="cursor: pointer"
                        @click="removeKeyWord(keyWord)"
                    >
                      mdi-close
                    </v-icon>
                  </p>
                </section>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-row class="ma-0 mx-2">
            <v-col
              cols="12"
              sm="6"
              md="6"
              lg="6"
              class="d-flex justify-lg-end justify-md-end"
            >
              <v-btn
                class="cancel-button"
                height="50"
                outlined
                width="100%"
                elevation="0"
                @click="close"
              >
                Cancelar
              </v-btn>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6">
              <v-btn
                class="cadaster-button"
                dark
                height="50"
                elevation="0"
                width="100%"
                @click="openDialog"
              >
                <span>Cadastrar subcategoria</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </div>

    <v-dialog v-model="confirmDialog" max-width="500">
      <ConfirmModal
        textMessage="Aviso de alterações"
        cancelBtn="Cancelar"
        title="Atenção"
        okbtn="Sim"
        textObservation1="Se você editar essa subcategoria, ela será editada em todos os produtos em uso!"
        @close="confirmDialog = false"
        @action="submit"
      />
    </v-dialog>
  </div>
</template>

<style scoped>
.keyWords{
  border: 2px solid #BC0000;
  border-radius: 6px;
  padding: 10px;
}
.keyWord{
  background: #BC0000;
  padding: 2px 10px;
  border-radius: 12px;
  color: #FFFFFF;
  font-weight: 500;
}
.label {
  font-style: normal;
  font-weight: 300;
  font-size: 18px;
  line-height: 20px;
  text-align: center;
  color: #9c9c9c;
}

.label-details {
  font-style: normal;
  font-weight: 300;
  font-size: 15px;
  line-height: 18px;
  letter-spacing: 0.15px;
  color: #979797;
}

.cadaster-button {
  border-radius: 7.5px !important;
  transition: 0.3s;
  background: #bc0000 !important;
  font-weight: bold !important;
  font-size: 18px;
  line-height: 27px;
  letter-spacing: 0.15px;
  font-size: 18px;
  color: #ffffff;
}

.cadaster-button:hover {
  color: white !important;
  background: #e8161e !important;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);
}

.cancel-button {
  border-radius: 7.5px !important;
  border: 2px solid #2d3038;
  box-sizing: border-box;
  font-weight: bold;
  transition: 300ms;
}

.cancel-button:hover {
  background: #2d3038;
  color: white !important;
}

.cancel-button:focus {
  background: #444854;
  color: white !important;
}
</style>

<script scoped>
import ApiService from "../../../../../services/ApiService";
import ConfirmModal from "../../../components/ConfirmModal.vue";
import Vue from "vue";

export default {
  name: "newSubCategory",

  props: {
    textMessage: String,
    icone: String,
    title: String,
    route: String,
    typeRoute: String,
    subcategory: Object,
  },

  created() {
    if (this.subcategory.name != null) {
      this.currentSubCategory = this.subcategory;
      this.keyWords = this.currentSubCategory.keyWords ? this.currentSubCategory.keyWords.split(',') : [];
      this.isEditing = true;
    } else {
      this.isEditing = false;
    }
  },

  data: () => ({
    confirmDialog: false,
    valid: false,
    secondValid: true,
    loading: false,
    isEditing: false,
    apiService: new ApiService(),
    currentSubCategory: {},
    keyWord: null,
    keyWords: [],
  }),

  components: {
    ConfirmModal,
  },

  methods: {
    onEditorChange({quill, html, text}) {
      this.currentSubCategory.descriptionHtml = html
      this.currentSubCategory.description = text
    },
    addkeyWord(){
      if(this.keyWord) {
        this.keyWords.push(this.keyWord.trim())
        this.keyWord = null
      }
    },

    removeKeyWord(keyWord){
      const index = this.keyWords.findIndex((x) => x === keyWord);
      this.keyWords.splice(index, 1);
    },

    action() {
      this.$emit("action");
    },

    close() {
      this.$emit("close");
    },

    openDialog() {
      if (this.isEditing) {
        this.confirmDialog = true;
      } else {
        this.submit();
      }
    },

    async submit() {
      this.loading = true;

      if (this.$refs.form.validate()) {
        const subcategory = this.currentSubCategory;
        subcategory.keyWords = this.keyWords.join(', ');
        let url = "subcategory/add";
        if (this.isEditing) {
          url = "subcategory/edit";
        }

        await this.apiService
          .post(url, subcategory)
          .then((resp) => {
            let token = localStorage.getItem("token");
            if (token) {
              this.close();
            } else {
              this.$router.push("/auth");
            }

            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "success",
              title: "Subcategoria cadastrada com sucesso!",
              message: resp.message,
              trace: null,
            });

            this.loading = false;
          })
          .catch((err) => {
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "error",
              title: "Erro ao cadastrar",
              message: err.body.message,
              trace: null,
            });

            this.loading = false;
          });
      } else {
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "error",
          title: "Formulário não validado",
          message: "Confira o preenchimento",
          trace: null,
        });

        this.loading = false;
      }
    },
  },
};
</script>
